import { jsx as e } from "react/jsx-runtime";
const t = (l) => {
  const { noItemMessage: s, className: n } = l;
  return s ? /* @__PURE__ */ e("ul", { className: n, role: "menu", children: /* @__PURE__ */ e("li", { className: "no-item-message disabled", role: "presentation", children: /* @__PURE__ */ e("a", { role: "menuitem", children: /* @__PURE__ */ e("i", { children: s }) }) }) }) : null;
};
export {
  t as default
};
//# sourceMappingURL=NoItemMessage.js.map
